export default __webpack_public_path__ + "static/Face1-8aa6d54d941f4b7ab77ac875751fa111.jpg";